import { cn } from "@/lib/utils";

interface PageHeaderProps {
  title: string;
  description?: string;
  className?: string;
  children?: React.ReactNode;
  badge?: React.ReactNode;
  /** HTML heading element to render. Defaults to 'h1'. Use 'h2' in contexts where a page-level h1 already exists. */
  as?: "h1" | "h2" | "h3";
}

export function PageHeader({ title, description, className, children, badge, as: Heading = "h1" }: PageHeaderProps) {
  return (
    <div className={cn("text-center mb-12 pt-8 relative z-10", className)}>
      {badge && (
        <div className="inline-flex justify-center mb-6">
          {badge}
        </div>
      )}
      <Heading className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-secondary mb-6 leading-tight tracking-tight">
        {title}
      </Heading>
      {description && (
        <p className="text-lg md:text-xl text-muted-foreground/90 max-w-3xl mx-auto leading-relaxed px-4">
          {description}
        </p>
      )}
      {children}
    </div>
  );
}
